import { render, staticRenderFns } from "./CreateTermMultiLanguage.vue?vue&type=template&id=998f03a4"
import script from "./CreateTermMultiLanguage.vue?vue&type=script&lang=js"
export * from "./CreateTermMultiLanguage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports